import * as Yup from 'yup';
import { validationMessages } from '../../../utils/FormUtils';
import hashCode from '../../../utils/StringUtil';


const buildValidationSchema = (formatMessage, accountData) => {
  const shape = {
    firstName: Yup.string().required(formatMessage(validationMessages.required)),
    lastName: Yup.string().required(formatMessage(validationMessages.required)),
    email: Yup.string()
      .required(formatMessage(validationMessages.required))
      .email(formatMessage(validationMessages.email)),
    gender: Yup.string().required(formatMessage(validationMessages.required)),
    type: Yup.string().required(formatMessage(validationMessages.required)),
  };

  accountData.account.globalAriFields.forEach((field) => {
    switch (field.dataType) {
      case 'TEXT':
        if (field.mandatory) {
          shape[`global_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'NUMBER':
        if (field.mandatory) {
          shape[`global_${field.id}_${hashCode(field.question)}`] = Yup
            .number()
            .typeError(formatMessage(validationMessages.notANumber))
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'DROPDOWN':
        if (field.mandatory) {
          shape[`global_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;

      default:
        break;
    }
  });

  accountData.account.localAriFields.forEach((field) => {
    switch (field.dataType) {
      case 'TEXT':
        if (field.mandatory) {
          shape[`local_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'NUMBER':
        if (field.mandatory) {
          shape[`local_${field.id}_${hashCode(field.question)}`] = Yup
            .number()
            .typeError(formatMessage(validationMessages.notANumber))
            .required(formatMessage(validationMessages.required));
        }
        break;
      case 'DROPDOWN':
        if (field.mandatory) {
          shape[`local_${field.id}_${hashCode(field.question)}`] = Yup.string()
            .required(formatMessage(validationMessages.required));
        }
        break;

      default:
        break;
    }
  });

  return Yup.object().shape(shape);
};

export default buildValidationSchema;
